// extracted by mini-css-extract-plugin
export default {"download":"download___f9oJrS9"};